module.exports = __webpack_public_path__ + "img/icon-scene-3.bb00b056.png";